import { useState } from "react";
import * as IconsSVG from "../../../../assets/iconsSVG";
import PesquisarCorretor from "./pesquisarCorretor";
import TabelaFila from "./tabelaFila";

import * as S from "./styles";

interface IFilaInscricaoProps {
  dataListarFila: any;
  refetchListarFila: () => void;
}

const FilaInscricao = ({
  dataListarFila,
  refetchListarFila,
}: IFilaInscricaoProps) => {
  const [palavraChave, setPalavraChave] = useState("");

  const filaCompleta = dataListarFila?.fila || [];

  const filaFiltrada = filaCompleta.filter((item: any) => {
    const termo = palavraChave.toLowerCase();
    const nomeCorretor = item?.nomeCorretor?.toLowerCase() || "";
    const equipeCorretor = item?.nomeEquipeCorretor?.toLowerCase() || "";
    const imobiliaria = item?.imobiliaria?.toLowerCase() || "";

    return (
      nomeCorretor.includes(termo) ||
      equipeCorretor.includes(termo) ||
      imobiliaria.includes(termo)
    );
  });

  return (
    <S.Container>
      <S.ContentTitle>
        <IconsSVG.FilaInscricaoIcon
          color1="#4CAF50"
          color2="#D1FADF"
          color3="#ECFDF3"
        />
        <S.Title>Fila de inscrição</S.Title>
      </S.ContentTitle>
      <S.ContentBody>
        <PesquisarCorretor
          dataListarFila={dataListarFila}
          onChangePalavraChave={(valor) => setPalavraChave(valor)}
          refetchListarFila={refetchListarFila}
        />
        <TabelaFila
          dataListarFila={{
            ...dataListarFila,
            fila: filaFiltrada,
          }}
          refetchListarFila={refetchListarFila}
        />
      </S.ContentBody>
    </S.Container>
  );
};
export default FilaInscricao;
